<template>
  <section class="text-gray-700 text-gray-800 font-display">
    <div class="block mb-5 mt-5">
      <router-link
        class="bg-indigo-500 text-white px-5 py-3 text-lg rounded shadow-2l font-bold"
        :to="{ name: 'estico.create' }"
      >
        <font-awesome-icon icon="plus" class="mr-2" />
        Criar um novo
      </router-link>
    </div>
    <div class="bg-gray-100 shadow-2l overflow-hidden sm:rounded-lg">
      <div class="px-4 py-5 sm:px-6">
        <h1 class="sm:text-2xl text-3xl font-bold title-font">Meus Esticos</h1>
        <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
          Listando todos os esticos cadastrados
        </p>
      </div>
      <div>
        <div class="flex flex-row flex-wrap flex-grow">
          <div class="w-full font-display text-gray-700">
            <ui-confirm
              ref="scaleDownConfirm"
              title="Você gostaria de remover?"
              transition="scale-down"
              confirmButtonText="Deletar"
              type="danger"
              confirmButtonIcon="delete"
              @confirm="onConfirm"
              @deny="onDeny"
              >Você gostaria de remover?</ui-confirm
            >
            <div class="w-full rounded-b-lg bg-white">
              <div
                class="overflow-auto sm:overflow-x-auto md:overflow-x-auto p-5"
              >
                <table
                  class="text-left border-collapse w-full table-responsive"
                >
                  <thead>
                    <tr>
                      <th
                        class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      ></th>
                      <th
                        class="w-1/4 py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      >
                        URL
                      </th>
                      <th
                        class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      >
                        Total
                      </th>
                      <th
                        class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      >
                        Preço
                      </th>
                      <th
                        class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      >
                        Frete
                      </th>
                      <th
                        class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      >
                        Custo
                      </th>
                      <th
                        class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      >
                        Pedidos
                      </th>
                      <th
                        class="w-1/6 py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td class="border-dashed border-t border-gray-200 px-3">
                        <img
                          class="rounded-full"
                          :src="
                            require(`@/assets/img/${item.intermediary.slug}.png`)
                          "
                          width="20px"
                          :alt="item.intermediary.name"
                        />
                        <ui-tooltip position="bottom" animation="fade">{{
                          item.intermediary.name
                        }}</ui-tooltip>
                      </td>
                      <td class="border-dashed border-t border-gray-200 px-3">
                        <a
                          href
                          @click.prevent="doCopy(item.token)"
                          class="text-indigo-500 font-bold p-1 bg-gray-200 rounded text-sm"
                        >
                          <font-awesome-icon icon="link" class="mr-2" />
                          pay.estico.me/{{ item.token }}
                          <ui-tooltip position="bottom" animation="fade"
                            >Copiar link</ui-tooltip
                          >
                        </a>
                      </td>
                      <td class="border-dashed border-t border-gray-200 px-3">
                        {{ item.total_price | toCurrency }}
                      </td>
                      <td class="border-dashed border-t border-gray-200 px-3">
                        {{ item.price | toCurrency }}
                      </td>
                      <td class="border-dashed border-t border-gray-200 px-3">
                        {{ item.shipping_amount | toCurrency }}
                      </td>
                      <td class="border-dashed border-t border-gray-200 px-3">
                        {{ item.cost_price | toCurrency }}
                      </td>
                      <td class="border-dashed border-t border-gray-200 px-3">
                        <span
                          class="relative inline-block px-3 py-1 font-bold text-green-900 leading-tight"
                        >
                          <span
                            aria-hidden
                            class="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                          ></span>
                          <span class="relative">{{
                            item.checkouts_count
                          }}</span>
                        </span>
                      </td>
                      <td
                        class="border-dashed border-t border-gray-200 px-3 py-3"
                      >
                        <router-link
                          :to="{
                            name: 'estico.show',
                            params: { id: item.token }
                          }"
                          class="mr-1 relative inline-block px-2 py-1 font-bold text-blue-500 leading-tight bg-blue-100 rounded-full"
                        >
                          <font-awesome-icon icon="eye" />
                          <ui-tooltip position="bottom" animation="fade"
                            >Visualizar</ui-tooltip
                          >
                        </router-link>
                        <a
                          @click="showConfirm('scaleDownConfirm', item.token)"
                          class="mr-1 cursor-pointer relative inline-block px-2 py-1 font-bold text-red-500 leading-tight bg-red-100 rounded-full"
                        >
                          <font-awesome-icon icon="trash-alt" />
                          <ui-tooltip position="bottom" animation="fade"
                            >Remover</ui-tooltip
                          >
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full mt-5">
      <pagination
        :pagination="pagination"
        @paginate="myEstico()"
        :offset="3"
      ></pagination>
    </div>
  </section>
</template>

<script>
import Pagination from '@/components/Pagination'
// @ is an alias to /src
export default {
  name: '',
  components: {
    pagination: Pagination
  },
  data() {
    return {
      confirmResult: '',
      deletedToken: '',
      clipboard: '',
      items: [],
      pagination: {}
    }
  },
  methods: {
    showConfirm(ref, token) {
      this.deletedToken = token
      this.$refs[ref].open()
    },
    hideConfirm(ref) {
      this.$refs[ref].close()
    },
    onConfirm() {
      this.$store
        .dispatch('DELETE_ESTICO', this.deletedToken)
        .then((response) => {
          this.deletedToken = null
          this.myEstico()
          this.$toasted.success('Removido com sucesso!', {
            position: 'top-center',
            duration: 5000,
            icon: 'delete'
          })
        })
        .catch((error) => {
          this.$toasted.error('Error!' + error, {
            position: 'top-center',
            duration: 5000,
            icon: 'close'
          })
        })
    },
    onDeny() {
      this.confirmResult = 'You denied the request.'
    },
    myEstico() {
      const page = this.pagination.current_page
        ? this.pagination.current_page
        : 1
      this.$store.dispatch('MY_ESTICO', page).then((response) => {
        this.items = response.data.data
        this.pagination = {
          total: response.data.total,
          per_page: response.data.per_age,
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          from: response.data.from,
          to: response.data.to
        }
      })
    },
    doCopy(text) {
      const url = 'https://pay.estico.me/' + text
      this.$copyText(url).then(
        (e) => {
          this.$toasted.success('Link copiado!', {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
        },
        function (e) {
          this.$toasted.error('Erro copiado!', {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
        }
      )
    }
  },
  mounted() {
    this.myEstico()
  }
}
</script>
